import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

export const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.2s ease-out;
  padding: 20px;
  box-sizing: border-box;
  isolation: isolate;
  contain: layout style paint;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

export const DialogContainer = styled.div`
  background: ${Tokens.ColorWhite};
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  width: 100%;
  max-width: 60%;
  max-height: 90vh;
  animation: slideIn 0.3s ease-out;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin: auto;
  isolation: isolate;
  contain: layout style paint;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-30px) scale(0.9);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`

export const ModalHeader = styled.div`
  padding: 24px 24px 16px 24px;
  border-bottom: 1px solid ${Tokens.ColorBorder};
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h1 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: ${Tokens.ColorTextPrimary};
    flex: 1;
  }
`

export const ModalContent = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  overflow-y: auto;
`

export const ThemeInfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background-color: ${Tokens.ColorBackground};
  border-radius: 8px;
  border: 1px solid ${Tokens.ColorBorder};
`

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  span:first-child {
    font-weight: 600;
    color: ${Tokens.ColorTextSecondary};
    font-size: 14px;
  }

  span:last-child {
    font-weight: 500;
    color: ${Tokens.ColorTextPrimary};
    font-size: 14px;
  }
`

export const ModalFooter = styled.div`
  padding: 16px 24px 24px 24px;
  border-top: 1px solid ${Tokens.ColorBorder};
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;
`

export const PremiseSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const PremiseHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const PremiseLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
`

export const PremiseCounter = styled.span`
  font-size: 12px;
  color: #6b7280;
`

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0;
`

export const PremiseTextArea = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 12px;
  border: 1px solid #dee2ef;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: ${Tokens.ColorUIPrimary};
  }

  &:disabled {
    background-color: #f9fafb;
    color: #6b7280;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #9ca3af;
  }
`
